import React, { FunctionComponent } from "react"
import { useMsal } from "@azure/msal-react"
import appService from "src/AppService"
import stateService from "src/utilities/AsyncStateManager/StateService"
import "./Logout.css"

const LogoutButton: FunctionComponent = () => {
    const { updateState } = stateService
    const { clearSession } = appService
    const { instance } = useMsal()

    const handleLogout = () => {
        try {
            instance.logoutPopup()
                .then(() => {
                    clearSession()
                    localStorage.clear()
                    updateState("appState", [
                        { key: "authenticated", value: false }
                    ])
                })
                .catch(err => {
                    console.error(err)
                    localStorage.clear()
                    updateState("appState", [
                        { key: "authenticated", value: false }
                    ])
                })
        } catch (err) {
            console.error(err)
            localStorage.clear()
            updateState("appState", [
                { key: "authenticated", value: false }
            ])
        }
    }

    return (
        <div
            id="c18bfaab57543fbcbcf5080d3f123c"
            className="dropdown-item"
            onClick={() => handleLogout()}
        >
            <div className="d-flex">
                <i className="material-icons mr-1"
                >warning
                </i>
                Sign Out
            </div>
        </div>
    )
}

export default LogoutButton
